/*
 * @Author: Fan
 * @Date: 2020-04-13 15:36:59
 * @LastEditTime: 2020-06-17 11:01:37
 * @LastEditors: zhuqiu
 * @Description: 控件拥有的属性和属性的值类型和在设计端属性栏名称. 属性独特的行为是在 conduct文件配置.
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\ShortText\schema.ts
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "shortText",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
            default: "",
        },
        name_i18n: {
            type: DataType.Object,
            title: i18n.t('dataitem.MultiLanguage').toString(),
        },
        visible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Visible').toString(),
            default: true,
        },
        dataItemName: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemCode').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        dictionaryData: {
            type: DataType.String,
            title: i18n.t('dataitem.DataDictionary').toString(),
        },
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        style: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlStyle').toString(),
        },
        tips: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlTips').toString(),
        },
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
        },
        onChange: {
            type: DataType.String,
            title: i18n.t('dataitem.ChangeEvent').toString(),
        },
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
        readonlyFormula: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.ReadonlyFormula').toString(),
            default: false,
        },
        defaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        regexp: {
            type: DataType.String,
            title: i18n.t('dataitem.Regex').toString(),
        },
        regexpText: {
            type: DataType.String,
            title: i18n.t('dataitem.RegexErrTips').toString(),
        },
        placeholder: {
            type: DataType.String,
            title: i18n.t('dataitem.Placeholder').toString(),
            default: i18n.t('dataitem.InputPlaceholder').toString(),
        },
        maxLength: {
            type: DataType.Integer,
            title: i18n.t('dataitem.MaxLength').toString(),
            maximum: 2000,
            default: 2000,
        },
        noRepeat: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.DeDuplicateVerification').toString(),
            default: false,
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        shortTextStitch: {
            type: DataType.String,
            title: i18n.t('dataitem.CalculationRules').toString(),
        },
        isScan: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.InputByScanCode').toString(),
            default: false,
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
